import React from 'react';
import { Target, Eye, ShieldCheck, Zap, Heart } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import './mission-vision.css';

const highlights = [
  { icon: ShieldCheck, text: 'RBI-regulated lending partner' },
  { icon: Zap, text: 'Fast, digital-first journey' },
  { icon: Heart, text: 'Customer-first at every step' },
];

const blocks = [
  {
    num: '01',
    icon: Target,
    title: 'Our Mission',
    accent: 'mint',
    text: 'To make Ultra Short Term Loans simple, swift, and accessible for salaried professionals. We deliver transparent, affordable solutions through Marathon Finlease — an RBI-registered NBFC — with every experience built on trust and integrity.',
  },
  {
    num: '02',
    icon: Eye,
    title: 'Our Vision',
    accent: 'cyan',
    text: "To transform how India's salaried workforce experiences personal finance — opening access to credit when it matters most, and using technology to make financial inclusion a reality for everyone.",
  },
];

const MissionVision = () => {
  return (
    <section className="mv-page" aria-labelledby="mv-aside-title">
      <div className="mv-layout">
        <aside className="mv-aside">
          <ScrollReveal y={20}>
            <p className="mv-aside-label">Purpose &amp; direction</p>
            <h2 id="mv-aside-title" className="mv-aside-title">
              Mission &amp; Vision
            </h2>
            <p className="mv-aside-text">
              The principles that guide how we lend, support, and grow with every borrower we serve.
            </p>

            <div className="mv-aside-box">
              <h3>What we stand for</h3>
              <ul>
                {highlights.map(({ icon: Icon, text }) => (
                  <li key={text}>
                    <Icon size={16} strokeWidth={2.2} aria-hidden />
                    {text}
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        </aside>

        <div className="mv-main">
          {blocks.map(({ num, icon: Icon, title, accent, text }, i) => (
            <ScrollReveal key={num} y={28} delay={i * 0.08}>
              <article className={`mv-block mv-block--${accent}`}>
                <span className="mv-block-num" aria-hidden="true">
                  {num}
                </span>
                <div className="mv-block-head">
                  <span className="mv-block-icon">
                    <Icon size={20} strokeWidth={2.2} aria-hidden />
                  </span>
                  <h3>{title}</h3>
                </div>
                <p>{text}</p>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
